import Localbase from 'localbase';
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import db from "./database";
import Tables from "./tables";
import Client from "../types/Client";
import Question from "../types/Question";
import Unite from '../types/Unite';

export function useGetClientFromUrl() {
  const { clientId } = useParams<{ clientId: string }>();
  const [client, setClient] = useState<Client>(new Client());
  const [error, setError] = useState<string>();

  useEffect(
    () => {
      const getClient = async () => {
        const currentClient: Client = await db().collection(Tables.CLIENTS).doc({ id: parseInt(clientId) }).limit(1).get();
        if (!currentClient) {
          setError('Impossible de trouver le client');
        }
        setClient(currentClient);
      }
      getClient();
    },
    [clientId],
  );

  return { client, error };
}
export function useGetQuestionsFromUrl() {
  const { questionnaire } = useParams<{ questionnaire: string }>();
  const [questions, setQuestions] = useState<Question[]>([]);
  const [error, setError] = useState<string>();

  useEffect(
    () => {
      const getQuestions = async () => {
        const currentQuestions: Question[] = await new Localbase('parvisio-itinerant').collection(Tables.QUESTIONS).get();
        if (!currentQuestions || currentQuestions.length === 0) {
          setError('Impossible de trouver les questions');
        } else {
          setQuestions(currentQuestions.filter(question => question.nom === questionnaire ));
        }
      }
      getQuestions();
    },
    [questionnaire],
  );

  return { questions, error };
}

export function useGetUnites() {
  const [unites, setUnites] = useState<Unite[]>([]);
  useEffect(
    () => {
      async function getUnites() {
        const unites = await db().collection(Tables.UNITES).get();
        console.log('[hook] unites:', unites);
        setUnites(unites);
      }
      getUnites();
    },
    [],
  );
  return unites;
}